import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackVisit } from '../actions/visitTracker';

// Renders nothing - just watches the route and logs one entry per page
// actually landed on. Needs to live inside <Router> to use useLocation,
// which is why it's a small function component sitting alongside
// CustomNavbarRoute instead of being folded into the class-based App.
export default function VisitTracker() {
    const { pathname } = useLocation();
    const lastLoggedPath = useRef(null);

    useEffect(() => {
        if (lastLoggedPath.current === pathname) return;
        lastLoggedPath.current = pathname;
        trackVisit(pathname);
    }, [pathname]);

    return null;
}
